import { Colors } from './types/colors';

export const dark: Colors = {
  // Brand
  brandPrimary: '#5466fd',
  brandHover: '#2d48d6',
  brandSecondary: '#bdccff',
  brandThirtiary: '#eef6ff',
  brandElement: '#6587ff',
  brandBackground: '#e5ebff',
  brandActive: '#6587ff',
  brandDisabled: '#9094ff',
  brandPrimaryText: '#ffffff',
  brandSecondaryText: '#ffffff',
  brandActiveText: '#ffffff',
  brandDisabledText: 'rgba(255, 255, 255, 0.8)',
  brandHoverText: 'rgba(255, 255, 255, 0.8)',

  // UI
  uiMain: '#fbfbfb',
  uiSecondary: '#9a98a9',
  uiBorder: '#8a899a',
  uiElementBackground: '#565562',
  uiInactive: '#5f5e6e',
  uiMainBackground: '#4d4c57',
  uiWebBackground: '#35343c',
  uiSeparator: '#7a788c',
  uiNeutral: '#7a788c',
  uiContrast: '#646374',
  uiKey: '#7a788c',
  uiMainSelected: '#4f4d5b',
  uiElementSecondary: '#605f6d',
  uiOutline: '#676675',
  uiSolid: '#ffffff',
  uiHover: 'rgba(162, 164, 180, 0.15)',
  uiMenu: '#3d3d47',

  // Attention
  attentionAlarm: '#ff3877',
  attentionAlarmHover: '#fa5a8d',
  attentionAlarmBorder: '#e584a3',
  attentionAlarmBackground: '#603d4e',
  attentionAlarmInactive: '#854363',

  attentionWarning: '#fad30b',
  attentionWarningBackground: '#fdf8dc',

  attentionNeutral: '#e05c85',
  attentionPositive: '#95f972',
  attentionAlarmTransaction: '#ff8ab4',

  attentionAlarmSecondary: '#ed1eff',
  attentionAlarmHoverSecondary: '#c233ce',
  attentionAlarmBorderSecondary: '#d284d9',
  attentionAlarmBackgroundSecondary: '#f8dafb',
  attentionAlarmInactiveSecondary: '#f1d4f3',

  // Effects
  topBarShadow: '0px 8px 22px rgba(19, 20, 28, 0.4)',
  mainWindowShadow: '0px 8px 24px rgba(34, 35, 47, 0.8)',
  selectedWindowShadow: '0px 18px 41px rgba(32, 34, 44, 0.79)',

  popover: '#4d4c57',
  popoverShadow: '0px 4px 21px rgba(34, 37, 51, 0.81)',

  popoverDark: '#4d4c57',
  popoverDarkShadow: '0px 7px 24px rgba(13, 18, 28, 0.34)',

  inputField: '#4d4c57',
  inputFieldBright: '#4d4c57',

  blueShadow: '0px 7px 28px rgba(31, 51, 216, 0.57)',

  overlay: '#4d4c57',
  overlayModal: '#4d4c57',

  // Tiles
  darkTileShadow: '0px 7px 19px rgba(11, 12, 14, 0.52)',
  blueTileShadow: '0px 7px 19px rgba(22, 41, 199, 0.52)',
  whiteTileShadow: '0px 8px 24px rgba(45, 46, 53, 0.8)',
  darkTileHoverShadow: '0px 7px 22px rgba(13, 14, 17, 0.62)',
  blueTileHoverShadow: '0px 7px 22px rgba(28, 44, 194, 0.62)',
  whiteTileHoverShadow: '0px 8px 24px rgba(45, 46, 53, 0.8)',
};
